import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindRuntimeConfig from './tailwindRuntimeConfig';

export const zeosTheme = resolveConfig(tailwindRuntimeConfig as any).theme;

//HACK: This is temporary until Tailwind typography is updated
export enum ZeosFontSize {
  //   xs = 0.75,
  //   sm = 1.125,
  //   md = 1.25,
  //   lg = 1.625,
  //   xl = 1.75,
  xs = "xs", // 0.75,
  lg = "lg", //1.125,
  xl = "xl", // 1.25,
  xxl = "2xl", //1.5
  xxxl = "3xl", //1.875,
}

export const contentWrapperClass = (contentType: string) => {
  // return contentType === "form"
  //   ? "grid grid-cols-1 sm:grid-cols-12 gap-x-6 gap-y-4 w-full"
  //   : "";
  return contentType === "form" ? "grid  gap-x-6 gap-y-4 w-full" : "";
};
